/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
interface IComponent002Props {
  text: string;
  img?: string;
  icon1?: string;
  icon2?: string;
  title1?: string;
  title2?: string;
  canDoItems: string[];
  cannotDoItems: string[];
  className?: string | null;
}

const Component002: React.FunctionComponent<IComponent002Props> = ({
  text,
  img,
  icon1,
  icon2,
  title1,
  title2,
  canDoItems,
  cannotDoItems,
  className,
}) => (
  <>
    <div className="component002">
      <div className={`component003 position-right ${className}`}>
        <div className="component003-tip">
          <span
            className="tip-text"
            dangerouslySetInnerHTML={{ __html: text }}
          />
          <div className="tip-arrow">
            <div className="line1" />
            <div className="line2" />
          </div>
        </div>
        <img src={require(`../../../../../assets/${img}`).default} alt="" />
      </div>
      <div className="cando-section">
        <div className="can-do">
          <div className="cando-img">
            <img
              src={require(`../../../../../assets/${icon1}`).default}
              alt=""
            />
          </div>
          <div className="cando-title" style={{ backgroundColor: '#E7444E' }}>
            {title1}
          </div>
          <div className="cando-body">
            <div className="cando-content">
              <ul>
                {canDoItems.map((itm: string, idx: number) => (
                  <li key={idx}>{itm}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="can-not-do">
          <div className="cando-img">
            <img
              src={require(`../../../../../assets/${icon2}`).default}
              alt=""
            />
          </div>
          <div className="cando-title" style={{ backgroundColor: '#E7444E' }}>
            {title2}
          </div>
          <div className="cando-body">
            <div className="cando-content">
              <ul>
                {cannotDoItems.map((itm: string, idx: number) => (
                  <li key={idx}>{itm}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
export default Component002;
